import React, { useEffect, useState } from 'react';
import {
  AppShell,
  Header,
  MediaQuery,
  Burger,
  Stack,
} from '@mantine/core';
import { useMantineTheme } from '@mantine/styles';
import { useAccessTokenCookie } from 'app/hooks/useAccessTokenCookie';
import { LayoutNavBar } from 'app/views/components/navigation/LayoutNavBar';
import { LayoutHeader } from 'app/views/components/layout/Header/LayoutHeader';

interface PageLayoutProps {
  children?: React.ReactNode;
  contentClassName?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children, contentClassName }) => {
  const theme = useMantineTheme();

  // made like this for refresh page with locale storage
  const [opened, setOpened] = useState<boolean>(() => {
    const savedOpened = localStorage.getItem('sidebarOpen');
    return savedOpened ? JSON.parse(savedOpened) : true;
  });

  // keeps the API client's token cookie fresh on every page; the app waits
  // for it before the first page renders (client/app.tsx)
  useAccessTokenCookie();

  // Update localStorage whenever `opened` changes
  useEffect(() => {
    localStorage.setItem('sidebarOpen', JSON.stringify(opened));
  }, [opened]);

  return (
    <AppShell
      styles={{
        main: {
          background:
            theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'white',
        },
      }}
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      navbar={<LayoutNavBar open={opened} setOpen={setOpened} />}
      header={
        <Header
          height={{ base: 90, md: 90, lg: 90 }}
          p="10px 20px 10px 0px"
          style={{ borderBottom: 'none', zIndex: 200 }}
        >
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <MediaQuery largerThan="sm" styles={{ display: 'none' }}>
              <Burger
                opened={opened}
                onClick={() => setOpened((prev) => !prev)}
                size="sm"
                color={theme.colors.gray[6]}
                mr="xl"
              />
            </MediaQuery>
            <LayoutHeader open={opened} />
          </div>
        </Header>
      }
    >
      <Stack className={contentClassName ? contentClassName + ' pageLayoutContent' : 'pageLayoutContent'}>
        {children}
      </Stack>
    </AppShell>
  );
};
